// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import axios from 'axios';
// import localstorage from 'vue-localstorage';
import VueMoment from 'vue-moment';
import lodash from 'lodash';

import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.css';

import App from './App';
import router from './router';

Vue.prototype.$http = axios;

// Vue.use(localstorage);
Vue.use(lodash);
Vue.use(Vuetify, axios);
Vue.use(VueMoment);

// NOTE: Mixin alert
Vue.mixin({
  data() {
    return {
      // NOTE: 알림 이벤트
      alert: {
        // NOTE: 에러
        type: 'error',              // 타입
        color: 'red',               // 타입에 따른 색상
        message: '',   // 메시지
        // NOTE: 성공의 아이콘과 색상
        // type: 'check_circle',
        // color: 'green',
      },
    };
  },
  methods: {
    alertOccur() {
      this.$eventBusAlert.$emit('alertOccur', this.alert);
    },
    alertClose() {
      this.$eventBusAlert.$emit('alertClose');
    },
  },
  beforeDestroy() {
    // NOTE: 컴포넌트가 없어지기전에 현재의 알림창 제거
    this.alertClose();
  },
});

Vue.config.productionTip = false;

// NOTE: App의 모든 에러 발생시 알림발생
Vue.prototype.$eventBusAlert = new Vue();
// Vue.prototype.$eventBusUser = new Vue();

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js